/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  CourseNameLink,
  EmbeddedPartnerNameTypography,
  StyledLink,
  getPartnerName,
} from 'bundles/common/lms-authoring/components/EmbeddedPartnerName';
import type { SourceCoursePartners } from 'bundles/common/lms-authoring/types/SourceCoursePartners';

import _t from 'i18n!nls/common';

type Props = {
  partners: SourceCoursePartners;
  courseName?: string;
  originalName?: string;
  className?: string;
  fullContentLink: string;
  courseSlug?: string | null;
};

export const TrimmedEmbeddedPartnerName = ({
  partners,
  courseName,
  originalName,
  className,
  fullContentLink,
  courseSlug,
}: Props) => {
  const { partnerName } = getPartnerName(partners);

  return (
    <EmbeddedPartnerNameTypography className={className}>
      <FormattedMessage
        message={_t(
          'This video includes a portion of the original lecture {lectureLink}, from the {courseName} course by {partnerName}'
        )}
        lectureLink={
          <StyledLink href={fullContentLink} data-testid="full-video-link">
            {originalName}
          </StyledLink>
        }
        courseName={<CourseNameLink courseName={courseName} courseSlug={courseSlug} />}
        partnerName={partnerName}
      />
    </EmbeddedPartnerNameTypography>
  );
};
